var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskDataSharing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M53.452,135H19.1V33h34.35q13.2,0,21.75,2.775a25.943,25.943,0,0,1,13.275,9.15,37.813,37.813,0,0,1,6.525,15,113.481,113.481,0,0,1,1.8,22.426,131.462,131.462,0,0,1-1.65,22.875,44.35,44.35,0,0,1-6.225,16.2,25.937,25.937,0,0,1-13.275,10.35Q66.951,135,53.452,135ZM75.2,94.5q.3-4.8.3-13.274a122.111,122.111,0,0,0-.6-13.576,25.94,25.94,0,0,0-2.85-9.3,11.867,11.867,0,0,0-6.675-5.776A36.58,36.58,0,0,0,53.452,51H39.8v66h13.65q11.25,0,16.35-5.7Q74.151,106.653,75.2,94.5Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.485,135,118.55,63.6h27.51L162.125,135h-14.49L144.8,122.085H119.81L116.975,135Zm27.3-59.43-7.245,33.915h19.53L134.825,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.29,76.41V63.6h52.5V76.41h-18.9V135H178.4V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.955,135,225.02,63.6h27.51L268.6,135h-14.49l-2.835-12.915H226.28L223.445,135Zm27.3-59.43-7.245,33.915h19.53L241.3,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.727,49.2q-16.351,0-16.35,10.8a8.179,8.179,0,0,0,4.05,7.351Q332.477,69.9,347.4,74.7t20.925,10.875q6,6.075,6,18.675,0,16.053-9.75,24.3t-25.5,8.25q-11.7,0-28.65-3.6l-5.4-1.05,2.1-16.049q20.1,2.7,30.75,2.7,15.9,0,15.9-13.2a8.784,8.784,0,0,0-3.675-7.5q-3.678-2.7-14.625-5.851-17.4-4.95-24.525-11.774T303.827,61.5q0-15.3,9.3-22.8t25.5-7.5q11.1,0,28.2,3l5.4,1.05L370.577,51.6Q349.427,49.2,340.727,49.2Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.7,135V105.391H399.135V135H384.646V63.6h14.489V92.79H425.7V63.6H440.19V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.644,135l16.065-71.4h27.51L507.284,135h-14.49l-2.835-12.915h-24.99L462.134,135Zm27.3-59.43L467.7,109.485h19.53L479.984,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.228,111.061V135h-14.49V63.6h27.72q25.2,0,25.2,23.519,0,13.966-10.5,20.58L567.343,135H551.488l-8.3-23.939Zm21.105-15.54a12.885,12.885,0,0,0,2.52-8.3,11.965,11.965,0,0,0-2.678-8.191q-2.678-3.043-7.717-3.045h-13.23V98.67h13.44Q547.812,98.67,550.333,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.737,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.667,135V63.6h24.465l17.22,58.8h1.05V63.6h14.49V135H639.057l-17.85-58.8h-1.05V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.046,109.38V96.78h20.79v37.066a160.51,160.51,0,0,1-24.36,2.414q-16.7,0-22.942-8.925t-6.248-28.35q0-19.424,6.51-28.035t22.155-8.61a111,111,0,0,1,21.105,2.2l3.78.735-.42,11.236a199.209,199.209,0,0,0-20.632-1.366q-8.033,0-11.288,1.89t-4.777,6.982q-1.524,5.1-1.523,17.431t3.045,17.273q3.045,4.936,12.6,4.934l8.715-.42V109.38Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskDataSharing);
export default __webpack_public_path__ + "static/media/BreachRisk_Data_Sharing.8c02eb9ec3ceddc7ace1160056862306.svg";
export { ForwardRef as ReactComponent };